// third-party
import { combineReducers } from 'redux';

// project imports
import snackbarReducer from './slices/snackbar';
import apiSlice from './slices/apis/apiSlice';
import projectApiSlice from './slices/apis/projectApiSlice';
// ==============================|| COMBINE REDUCER ||============================== //


const reducer = combineReducers({
    snackbar: snackbarReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
    [projectApiSlice.reducerPath]: projectApiSlice.reducer, // Add the API reducer
});
export default reducer;
